import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LoadingBlock } from "./Spinner";

/**
 * Oturum kapısı.
 *
 * Eski `configure.php` giriş yoksa `index.php?continue=<gelen url>` adresine
 * yönlendiriyordu ve `continue` parametresi doğrulanmadığı için açık yönlendirme
 * (G-24) açığı vardı. Burada hedef adres React Router state'inde taşınır —
 * URL'ye yazılmaz — ve Login ekranında yalnızca uygulama içi yol olduğu
 * doğrulandıktan sonra kullanılır.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingBlock label="Oturum doğrulanıyor" />
      </div>
    );
  }

  if (!session) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <>{children}</>;
}

export default RequireAuth;
